import { useMutation } from '@tanstack/react-query';
import { makeRequest } from 'features/entry-form-v2/data/makeRequest';
import { ApiError } from 'features/invite-users/useProjectInvitations';

const UNFREEZE_PROJECT = 'unfreezeProject';

interface UnfreezeProjectInput {
	projectId: number;
}

interface ProjectOperationResponse {
	statusCode: string;
}

interface UseProjectUnfreezeReturn {
	unfreezeProject: (details: UnfreezeProjectInput) => Promise<ProjectOperationResponse | void>;
	isUnfreezing: boolean;
}

export function useProjectUnfreeze(): UseProjectUnfreezeReturn {
	const unfreezeMutation = useMutation<ProjectOperationResponse, ApiError, UnfreezeProjectInput>(
		details =>
			makeRequest<ProjectOperationResponse>({
				service: 'projects',
				method: UNFREEZE_PROJECT,
				data: details
			}),
		{
			onError: (error: ApiError) => {
				console.error('Failed to unfreeze project (hook):', error);
			}
		}
	);

	const unfreezeProject = async (details: UnfreezeProjectInput) => {
		return unfreezeMutation.mutateAsync(details);
	};

	return {
		unfreezeProject,
		isUnfreezing: unfreezeMutation.isLoading
	};
}
